class Chatlio {
    constructor() {
        // flag indicating widget readiness
        this.ready = false;

        // maintain list of pending chatlio calls made before widget is initialised
        this.queue = [];
    }

    // to be invoked when the chatlio widget has been fully initialised
    onReady() {
        this.ready = true;

        // purge the queue of pending chatlio calls
        for (const item of this.queue) {
            this.call(item.method, ...item.args);
        }
        this.queue = [];
    }

    call(method, ...args) {
        if (!this.ready) {
            // if not ready, add the call to the queue
            this.queue.push({
                method,
                args,
            });
        } else {
            // otherwise, make the call to the chatlio library
            window._chatlio[method](...args);
        }
    }

    identify(user) {
        const chatlioUser = {};
        for (const key of ['name', 'email', 'display_name', 'username', 'source_type', 'source_id', 'bk_user_id']) {
            if (key === 'display_name') {
                chatlioUser[key] =
                    process.env.NODE_ENV === 'production'
                        ? user[key] || user.name || user.username
                        : `dev-${user[key] || user.name || user.username}`;
            } else if (user[key]) {
                chatlioUser[key] = user[key];
            }
        }

        this.call('identify', `${user.id}-${Date.now()}`, chatlioUser);
    }
}

export default new Chatlio();
